// Mui
import { Box, CircularProgress } from '@mui/material';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectIsPageLoading } from 'app/store/pagesToolbar/pagesToolbar.selectors';

type Props = {
  documentId: number;
  pageNum: number;
}

const PageLoadingPlaceholder = ({ documentId, pageNum }:Props) => {
  // State
  const isPageLoading = useAppSelector((state:any) => selectIsPageLoading(state, {
    documentId,
    pageNum
  }));

  if ( !isPageLoading ) return null;
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0, right: 0, bottom: 0, left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none'
      }}
    ><CircularProgress /></Box>
  )
}

export default PageLoadingPlaceholder